/**
 * De inlogcode van een kraam.
 *
 * Eén inlog per kraam; de code staat op het kaartje in de doos en wordt door
 * de telefoon voorgelezen als iemand hem kwijt is. Daarom zitten de tekens die
 * je door elkaar haalt er niet in: geen 0 tegenover O, geen 1 tegenover I.
 */

/** Tekens die niet met elkaar te verwarren zijn als je ze uitspreekt. */
export const CODE_TEKENS = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';

export interface InlogcodeInvoer {
  kraamnaam: string;
  /** Levert getallen van 0 tot 1. Los mee te geven, zodat een test vaststaat. */
  toeval?: () => number;
  staartLengte?: number;
}

export function maakInlogcode(invoer: InlogcodeInvoer): string {
  const toeval = invoer.toeval ?? Math.random;
  const lengte = invoer.staartLengte ?? 4;

  const kern =
    invoer.kraamnaam
      .toUpperCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/[^A-Z]/g, '')
      .slice(0, 6) || 'KRAAM';

  const staart = Array.from({ length: lengte }, () => {
    const positie = Math.trunc(toeval() * CODE_TEKENS.length);
    return CODE_TEKENS[Math.min(positie, CODE_TEKENS.length - 1)] ?? 'X';
  }).join('');

  return `${kern}-${staart}`;
}

/** Normaliseert wat iemand intypt: hoofdletters, geen spaties. */
export function normaliseerInlogcode(invoer: string): string {
  return invoer.trim().toUpperCase().replace(/\s+/g, '');
}
